export default __webpack_public_path__ + "static/media/bin.0149be0c.svg";